import { useRouteMatch } from "react-router-dom";

import { useMentionCards } from "@/contexts/MentionCardsContext";
import { ROUTES } from "@/routes_new";
import Modal, { ModalContent, ModalTitle } from "@components/Modal";
import { ModalProps } from "@components/Modal/Modal";

import Export from "./partials/Export";

import styles from "./TagExportModal.module.css";

const TagExportModal = (modalProps: ModalProps) => {
  const { tag } = useMentionCards();
  const isFavoritePage = useRouteMatch(ROUTES.FAVORITES_ORGID)?.isExact;

  if (!tag && !isFavoritePage) return null;

  return (
    <Modal className={styles.modal} {...modalProps}>
      <ModalTitle>
        {isFavoritePage
          ? L.EXPORT_FAVORITES
          : L.EXPORT_TAG_MODAL_TITLE.replaceAll("{}", `"${tag?.name}"`)}
      </ModalTitle>

      <ModalContent>
        <Export />
      </ModalContent>
    </Modal>
  );
};

export default TagExportModal;
